import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

/** Provides range validation for inputs that expect numbers.
 *  If input is not a number, or number specified is not within inclusive bounds, an error is returned.
 */
@Directive({
    selector: 'input[lexRange]',
    providers: [{ provide: NG_VALIDATORS, useExisting: RangeValidator, multi: true }],
    standalone: false
})
export class RangeValidator implements Validator {
    @Input() min: number;
    @Input() max: number;

    validate(control: AbstractControl): { [key: string]: any } {
        const val: number = +control.value;

        let result = null;
        if (isNaN(val)) {
            result = { NaN: {} };
            return result;
        }

        if (val < this.min) result = { ...result, ...{ min: { expected: this.min, actual: val } } };
        if (val > this.max) result = { ...result, ...{ max: { expected: this.max, actual: val } } };

        return result;
    }
}
